"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandConfig = void 0;
const callToBookConditions_1 = require("./data/callToBookConditions");
const cottagesDeposits_1 = require("./data/cottagesDeposits");
const hoseasonsDeposits_1 = require("./data/hoseasonsDeposits");
const popularFeatures_1 = require("./data/popularFeatures");
const sortOptions_1 = require("./data/sortOptions");
const imageSizes_1 = require("./data/imageSizes");
const featureIcons_1 = require("./data/featureIcons");
const defaultMaxZoomLevel = 16;
const novasolMaxZoomLevel = 22;
exports.brandConfig = {
    'cottages.com': {
        callToBookConditions: callToBookConditions_1.callToBookConditionsUK,
        checkoutPath: '/holiday-details',
        contactDetails: {
            telephoneNumbers: {},
        },
        contenfulEntryIds: {
            footer: 'Hl315LKwqQxWnEZ7Pmob9',
            header: '4nlMbXfyodUOXHXeQrA7H3',
        },
        deposits: cottagesDeposits_1.cottagesDeposits,
        featureFlags: {},
        featureIcons: featureIcons_1.featureIcons,
        mapOptions: { maxZoomLevel: defaultMaxZoomLevel },
        popularFeatureIds: popularFeatures_1.cottagesPopularFeatureIds,
        reevooAccountCode: 'HOS',
        sortOptions: sortOptions_1.cottagesSortOptions,
        staticAssetDomain: 'https://img.chooseacottage.co.uk',
        pdpUrlSegment: {
            cottages: 'search-results.property-card.pdp-url-segment.cottages',
            default: 'search-results.property-card.pdp-url-segment.cottages',
        },
        pdpResponsiveImageWidths: imageSizes_1.defaultImageSizes,
    },
    hoseasons: {
        callToBookConditions: callToBookConditions_1.callToBookConditionsUK,
        checkoutPath: '/cottages/summary',
        contactDetails: {
            telephoneNumbers: {},
        },
        contenfulEntryIds: {
            footer: '1IRrRzoUHYlAvlIf7Fth1V',
            header: '1otwoo0orurZwE01fV1AYf',
        },
        deposits: hoseasonsDeposits_1.hoseasonsDeposits,
        featureFlags: {},
        featureIcons: featureIcons_1.featureIcons,
        mapOptions: { maxZoomLevel: defaultMaxZoomLevel },
        popularFeatureIds: popularFeatures_1.hoseasonsPopularFeatureIds,
        reevooAccountCode: 'HSE',
        sortOptions: sortOptions_1.defaultSortOptions,
        staticAssetDomain: 'https://img.chooseacottage.co.uk',
        pdpUrlSegment: {
            cottages: 'search-results.property-card.pdp-url-segment.cottages',
            'holiday-parks': 'search-results.property-card.pdp-url-segment.holiday-parks',
            lodges: 'search-results.property-card.pdp-url-segment.lodges',
            default: 'search-results.property-card.pdp-url-segment.lodges',
        },
        pdpResponsiveImageWidths: imageSizes_1.defaultImageSizes,
    },
    agnostic: {
        checkoutPath: '',
        contactDetails: {
            telephoneNumbers: {},
        },
        contenfulEntryIds: {
            footer: 'Hl315LKwqQxWnEZ7Pmob9',
            header: '4nlMbXfyodUOXHXeQrA7H3',
        },
        deposits: cottagesDeposits_1.cottagesDeposits,
        featureFlags: {},
        featureIcons: new Map(),
        mapOptions: { maxZoomLevel: defaultMaxZoomLevel },
        popularFeatureIds: [],
        reevooAccountCode: 'HSE',
        sortOptions: sortOptions_1.defaultSortOptions,
        staticAssetDomain: 'https://img.chooseacottage.co.uk',
        pdpUrlSegment: {
            default: 'search-results.property-card.pdp-url-segment.cottages',
        },
        pdpResponsiveImageWidths: imageSizes_1.defaultImageSizes,
    },
    awaze: {
        checkoutPath: '',
        contactDetails: {
            telephoneNumbers: {},
        },
        contenfulEntryIds: {
            footer: 'Hl315LKwqQxWnEZ7Pmob9',
            header: '4nlMbXfyodUOXHXeQrA7H3',
        },
        deposits: cottagesDeposits_1.cottagesDeposits,
        featureFlags: {},
        featureIcons: new Map(),
        mapOptions: { maxZoomLevel: defaultMaxZoomLevel },
        popularFeatureIds: [],
        reevooAccountCode: 'HSE',
        sortOptions: sortOptions_1.defaultSortOptions,
        staticAssetDomain: 'https://img.chooseacottage.co.uk',
        pdpUrlSegment: {
            default: 'search-results.property-card.pdp-url-segment.cottages',
        },
        pdpResponsiveImageWidths: imageSizes_1.defaultImageSizes,
    },
    novasol: {
        callToBookConditions: callToBookConditions_1.callToBookConditionsNovasol,
        checkoutPath: 'https://checkout.novasol.com',
        contactDetails: {
            telephoneNumbers: {},
        },
        contenfulEntryIds: {
            footer: '4dCMxEiSuRYtMnvGbCwxGG',
            header: '5KOCQ0jlTlDnYmIAH1Hj4J',
        },
        deposits: [],
        featureFlags: {},
        featureIcons: featureIcons_1.novasolfeatureIcons,
        mapOptions: { maxZoomLevel: novasolMaxZoomLevel },
        popularFeatureIds: popularFeatures_1.novasolPopularFeatureIds,
        reevooAccountCode: 'HSE',
        sortOptions: sortOptions_1.novasolSortOptions,
        staticAssetDomain: 'https://image.novasol.com',
        pdpUrlSegment: {
            default: 'search-results.property-card.pdp-url-segment.holidayhome',
        },
        pdpResponsiveImageWidths: imageSizes_1.novasolImageSizes,
    },
    novasolOwner: {
        checkoutPath: '',
        contactDetails: {
            telephoneNumbers: {},
        },
        contenfulEntryIds: {
            footer: '4dCMxEiSuRYtMnvGbCwxGG',
            header: '5KOCQ0jlTlDnYmIAH1Hj4J',
        },
        deposits: [],
        featureFlags: {},
        featureIcons: featureIcons_1.novasolfeatureIcons,
        mapOptions: { maxZoomLevel: novasolMaxZoomLevel },
        popularFeatureIds: [],
        reevooAccountCode: 'HSE',
        sortOptions: sortOptions_1.defaultSortOptions,
        staticAssetDomain: 'https://image.novasol.com',
        pdpUrlSegment: {
            default: 'search-results.property-card.pdp-url-segment.holidayhome',
        },
        pdpResponsiveImageWidths: imageSizes_1.novasolImageSizes,
    },
    dansommer: {
        checkoutPath: '',
        contactDetails: {
            telephoneNumbers: {},
        },
        contenfulEntryIds: {
            footer: 'Hl315LKwqQxWnEZ7Pmob9',
            header: '4nlMbXfyodUOXHXeQrA7H3',
        },
        deposits: cottagesDeposits_1.cottagesDeposits,
        featureFlags: {},
        featureIcons: new Map(),
        mapOptions: { maxZoomLevel: defaultMaxZoomLevel },
        popularFeatureIds: [],
        reevooAccountCode: 'HSE',
        sortOptions: sortOptions_1.defaultSortOptions,
        staticAssetDomain: 'https://img.chooseacottage.co.uk',
        pdpUrlSegment: {
            default: 'search-results.property-card.pdp-url-segment.cottages',
        },
        pdpResponsiveImageWidths: imageSizes_1.novasolImageSizes,
    },
    fincallorca: {
        callToBookConditions: callToBookConditions_1.callToBookConditionsNovasol,
        checkoutPath: 'https://checkout.novasol.com',
        contactDetails: {
            telephoneNumbers: {},
        },
        contenfulEntryIds: {
            footer: '4dCMxEiSuRYtMnvGbCwxGG',
            header: '5KOCQ0jlTlDnYmIAH1Hj4J',
        },
        deposits: [],
        featureFlags: {},
        featureIcons: featureIcons_1.novasolfeatureIcons,
        mapOptions: { maxZoomLevel: novasolMaxZoomLevel },
        popularFeatureIds: popularFeatures_1.novasolPopularFeatureIds,
        reevooAccountCode: 'HSE',
        sortOptions: sortOptions_1.novasolSortOptions,
        staticAssetDomain: 'https://image.novasol.com',
        pdpUrlSegment: {
            default: 'search-results.property-card.pdp-url-segment.holidayhome',
        },
        pdpResponsiveImageWidths: imageSizes_1.novasolImageSizes,
    },
};
//# sourceMappingURL=brand.config.js.map